module.exports = __webpack_public_path__ + "static/media/pic15.77376f39.jpg";